import { createApp } from "vue";
import App from "./App.vue";
import router from "./router/index";
import "./assets/styles/main.css";
import { IS_ZUIMEI } from "@/utils/util";

// 引入 Element Plus 样式
import "element-plus/dist/index.css";

// 引入 Element Plus 和图标库
import ElementPlus from "element-plus";
import * as ElementPlusIconsVue from "@element-plus/icons-vue";

const app = createApp(App);

// 全局引入 Element Plus
app.use(ElementPlus);

// 全局引入所有图标
for (const [key, component] of Object.entries(ElementPlusIconsVue)) {
  app.component(key, component);
}

if (IS_ZUIMEI) {
  router.beforeEach((to, from, next) => {
    // 移动端重定向
    if (
      /Android|webOS|iPhone|iPad|iPod|BlackBerryi/i.test(navigator.userAgent)
    ) {
      const cityCode = to.query.cityCode;
      const mobileUrl = "https://web.zuimeitianqi.com/weatherweb/weather.html";
      location.href = cityCode ? mobileUrl + "?cityId=01012507" : mobileUrl;
    }

    next();
  });
}

app.use(router); // 使用路由
app.mount("#app");
